module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Regular.f86edf3.eot";